/* eslint-disable no-plusplus */
import './App.css'
import 'semantic-ui-css/semantic.min.css'
import 'react-datepicker/dist/react-datepicker.css'
// import { Route, BrowserRouter as Router } from 'react-router-dom'
import BaseComponent from './components/BaseComponent'
// import { Container } from 'semantic-ui-react'
import Cookies from 'universal-cookie'
// import OneFlowWithRouter from './flows/OneFlowWithRouter'
import React from 'react'
// import RecurFlowWithRouter from './flows/RecurFlowWithRouter'
// import StartPage from './pages/StartPage'
import _ from 'lodash'
import moment from 'moment'

class App extends BaseComponent {
	constructor() {
		super()
		// TODO: Put this in database and pull from there
		this.offer = {
			baseHourlyRate: 175,
			clientId: null,
			hoursTotalMinimum: 4,
			hoursTotalDefault: 15,
			workerName: 'Anthony Astige',
			workerGender: 'm', // m=male | f=female | o=other
			workerEmail: 'anthony@zinid.com',
			submitToEmail: 'prepaymentrequests@zinid.com',
			hoursTotalMaximum: 40 * 12,
			hoursPerWeekMin: 4,
			hoursPerWeekIdeal: 20,
			hoursPerWeekMax: 30,
			expiresAt: moment().add(1, 'week').toDate(),
			customText: 'The offer as we discussed last week',
			quantityDiscounts: [
				{
					minimumHours: 10,
					discount: 0.08
				},
				{
					minimumHours: 20,
					discount: 0.16
				}
			],
			advanceDiscounts: [
				{
					timeBeforeStartDate: [1, 'weeks'],
					discount: 0.08
				},
				{
					timeBeforeStartDate: [2, 'weeks'],
					discount: 0.16
				}
				/*
				,{
					timeBeforeStartDate: [4, 'weeks'],
					discount: 0.24
				}
				*/
			]
			/*
			 [RecurringIntervalOptions]
				 Enum: (Daily | Weekly | Monthly | Quarterly)
			 RecurringDefaultInterval (Null | Daily | Weekly | Monthly | Quarterly)
			 RecurringPaymentDiscountPercent
			 [AllowedPaymentMethod] (Enum: Check | ACH | Credit | more stripe options?)
			*/
		}
		this.generateCookieSaver = this.generateCookieSaver.bind(this)
		this.generateCookieGetter = this.generateCookieGetter.bind(this)
		this.cookies = new Cookies()
	}

	// Generates a function that gets cookie object at name that shallowly de-serializes moment objects
	generateCookieGetter(name) {
		return () => {
			const data = this.cookies.get(name) || {}
			return _.mapValues(data, o => (o.isMoment ? moment(o.valueOf) : o))
		}
	}

	// Generates a function to save objects as cookie at name w/shallow serializing moment objects
	generateCookieSaver(name) {
		const oneDay = 60 * 60 * 24
		return data => {
			const dataNoMoment = _.mapValues(
				data,
				o => (moment.isMoment(o) ? { isMoment: true, valueOf: o.valueOf() } : o)
			)
			this.cookies.set(name, dataNoMoment, { path: '/', maxAge: oneDay, secure: true })
		}
	}

	render() {
        return <h1>To contact me for rates please visit <a href="https://anthony.astige.com">https://anthony.astige.com</a></h1>
        /*
		return (
			<Router>
				<Container className="App">
					<Route
						exact
						path="/"
						render={() =>
							<StartPage
								advanceDiscounts={this.offer.advanceDiscounts}
								baseHourlyRate={this.offer.baseHourlyRate}
								minimumHours={this.offer.hoursTotalMinimum}
								quantityDiscounts={this.offer.quantityDiscounts}
								workerEmail={this.offer.workerEmail}
								workerName={this.offer.workerName}
							/>}
					/>
					<div>
						<Route path="/one">
							<OneFlowWithRouter
								offer={this.offer}
								initialState={this.generateCookieGetter('one')}
								saveState={this.generateCookieSaver('one')}
							/>
						</Route>
						<Route path="/recur">
							<RecurFlowWithRouter
								offer={this.offer}
								initialState={this.generateCookieGetter('recur')}
								saveState={this.generateCookieSaver('recur')}
							/>
						</Route>
					</div>
				</Container>
			</Router>
		)
        */
	}
}

export default App



// WEBPACK FOOTER //
// ./src/App.js